// extracted by mini-css-extract-plugin
module.exports = {"section":"LoginWidget_section__180ox"};